var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgShield = _a => {
  var _b, _c;
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 24,
    height: size !== null && size !== void 0 ? size : 24,
    viewBox: "0 0 24 24",
    role: props.role,
    "aria-hidden": (_b = props['aria-hidden']) !== null && _b !== void 0 ? _b : true
  }, props), React.createElement("path", {
    fill: (_c = props.color) !== null && _c !== void 0 ? _c : 'currentColor',
    fillRule: "evenodd",
    d: "M12.3354102,22.6708204 C12.1242646,22.7763932 11.8757354,22.7763932 11.6645898,22.6708204 C11.5929585,22.6350048 11.4665166,22.5686227 11.2930131,22.4725762 C11.0083114,22.3149734 10.6922315,22.1295804 10.3525008,21.9172487 C9.38303807,21.3113345 8.41370503,20.6085681 7.50612154,19.8144325 C4.85931975,17.498481 3.25,14.8833364 3.25,12 L3.25,4 C3.25,3.65584927 3.48422303,3.35586194 3.81809828,3.27239312 L11.8180983,1.27239312 C11.9375283,1.24253563 12.0624717,1.24253563 12.1819017,1.27239312 L20.1819017,3.27239312 C20.515777,3.35586194 20.75,3.65584927 20.75,4 L20.75,12 C20.75,14.8833364 19.1406802,17.498481 16.4938785,19.8144325 C15.586295,20.6085681 14.6169619,21.3113345 13.6474992,21.9172487 C13.3077685,22.1295804 12.9916886,22.3149734 12.7069869,22.4725762 C12.5334834,22.5686227 12.4070415,22.6350048 12.3354102,22.6708204 Z M12.8525008,20.6452513 C13.7580381,20.0792905 14.663705,19.4226819 15.5061215,18.6855675 C17.8593198,16.626519 19.25,14.3666636 19.25,12 L19.25,4.5855823 L12,2.7730823 L4.75,4.5855823 L4.75,12 C4.75,14.3666636 6.14068025,16.626519 8.49387846,18.6855675 C9.33629497,19.4226819 10.2419619,20.0792905 11.1474992,20.6452513 C11.4561993,20.8381888 11.7428084,21.0065894 12,21.1494312 C12.2571916,21.0065894 12.5438007,20.8381888 12.8525008,20.6452513 Z"
  }));
};
export default SvgShield;